import {
	httpRequest
} from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import qs from 'qs'

//商品详情
export const goodsdetailsshareModule = {
	goodsdetailsshare(store_goods_id, user_token) {
		return httpRequest(baseUrl.admin + 'goodsdetailshare?store_goods_id=' + store_goods_id + '&user_token=' +
			user_token, 'get', null, null);
	},
}

//店铺详情
export const storedetailsshareModule = {
	storedetailsshare(store_id, user_token, longitude, latitude) {
		return httpRequest(baseUrl.admin + 'storedetailshare?store_id=' + store_id + '&user_token=' + user_token +
			'&longitude=' + longitude + '&latitude=' + latitude, 'get', null, null);
	},
	storegoodslistshare(page_index, page_size, key_id, user_token) {
		return httpRequest(baseUrl.admin + 'goodslistshare?page_index=' + page_index + '&page_size=' + page_size +
			'&key_id=' + key_id + '&user_token=' + user_token, 'get', null, null);
	},

}

// 我的免单
export const freeshareorderModule = {
	// 我的免单-分享--hkk /freeshareorder
	freeshareorder(order_id) {
		return httpRequest(baseUrl.admin + 'freeshareorder?order_id=' + order_id, 'get', null, null);
	},
	// /freeorderlist  我的免单
	freeorderlist(userID, page, pageSize) {
		return httpRequest(baseUrl.admin + 'freeorderlist?userID=' + userID + '&page=' + page + '&pageSize=' +
			pageSize, 'get', null, null);
	},
}
// 系统设置
export const explainsettingModule = {
	// 系统设置--hkk //explainsettingdetailshare
	explainsettingdetailshare(explainID) {
		return httpRequest(baseUrl.admin + 'explainsettingdetailshare?&explainID=' + explainID, 'get', null, null);
	},
}
// 打榜活动
export const activitydetailModule = {
	// /activitydetailshare
	activitydetailshare(activity_id, user_token) {
		return httpRequest(baseUrl.admin + 'activitydetailshare?activity_id=' + activity_id + '&user_token=' +
			user_token, 'get', null, null);
	},
	// /activitycommentlistshare
	activitycommentlistshare(page_index, page_size, mark_type, activity_id, post_id, user_token) {
		return httpRequest(baseUrl.admin + 'activitycommentlistshare?page_index=' + page_index + '&page_size=' +
			page_size + '&mark_type=' + mark_type + '&activity_id=' + activity_id + '&post_id=' + post_id +
			'&user_token=' + user_token, 'get', null, null);
	},
}
// 文章
export const articlemodelshareModule = {
	// //articlemodelsharee
	articlemodelshare(article_id, user_token) {
		return httpRequest(baseUrl.admin + 'articlemodelshare?article_id=' + article_id + '&user_token=' +
			user_token, 'get', null, null);
	},
}

//下载/downloadurlshare
export const downloadurlshareModule = {
	// 系统设置--hkk //downloadurlshare
	downloadurlshare(mark_type) {
		return httpRequest(baseUrl.admin + 'downloadurlshare?mark_type=' + mark_type, 'get', null, null);
	},
}
// //  注册
export const userregistershareModule = {
	// /userregistershare
	userregistershare(login_name, login_pwd, device_type, device_token, verify_code, p_user_id, user_sn) {
		var paras = {
			login_name: login_name,
			login_pwd: login_pwd,
			device_type: device_type,
			device_token: device_token,
			verify_code: verify_code,
			p_user_id: p_user_id,
			user_sn: user_sn
		}
		return httpRequest(baseUrl.admin + 'userregistershare', 'post', qs.stringify(paras), null);
	},
	// /addmembersendcodeshare
	// 根据手机号 用户注册发送验证码 
	addmembersendcodeshare(verifyCodeType, userTel, userType) {
		// var header
		var paras = {
			verifyCodeType: verifyCodeType,
			userTel: userTel,
			userType: userType
		}
		return httpRequest(baseUrl.basic + 'addmembersendcodeshare', 'post', qs.stringify(paras), null);
	},
}
// /
